import { Divider, Form, Spin } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import { FormItem } from 'components/Form/FormItem'
import Label from 'components/Form/Label'
import RangeSliderInput from 'components/RangeSliderInput'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import AlertIcon from 'components/icons/AlertIcon'
import {
  AlertTag,
  AlertText,
  ContentDiv,
  DetailsNameDiv,
  DetailsTitleDiv,
  FlexWrap,
  LeftFlex,
  RightFlex,
  Space,
  SpinWrapper,
} from 'modules/Roles/Partials/RolesTable/CandidateRankingDrawer/styles'
import {
  getRoleRankingConfig,
  updateRoleRankingConfig,
} from 'modules/Roles/actions'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SuccessMessage from 'utils/SuccessMessage'

const CandidateRankingDrawer = ({
  openDrawer,
  setOpenDrawer,
  selectedRoleId,
  setPreviewDrawe,
  setCreaterDriveDrawer,
  allowToUpdate,
}) => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const rankingConfigList = useSelector(
    state => state?.corporate?.rankingConfigData
  )
  const [rankingList, setRankingList] = useState(rankingConfigList || [])
  const [isLoading, setIsLoading] = useState(true)
  const [isSubmit, setIsSubmit] = useState(false)

  const getRankingConfig = async () => {
    setIsLoading(false)
    let response = await dispatch(getRoleRankingConfig(selectedRoleId))
    setIsLoading(response)
  }

  useEffect(() => {
    if (selectedRoleId) getRankingConfig()
  }, [selectedRoleId])

  useEffect(() => {
    updateRankingForm(rankingConfigList)
    setRankingList(rankingConfigList || [])
  }, [rankingConfigList])

  useEffect(() => {
    updateRankingForm(rankingList)
  }, [rankingList])

  const updateRankingForm = rankList => {
    let formData = rankList?.map(({ id, roundAllotment }) => {
      return { id, roundAllotment }
    })
    form.setFieldsValue({
      roleRankConfigs: formData,
    })
  }

  const getAvlPercentage = (index, value) => {
    let topLevelPercentage = rankingList
      ?.filter((data, rankIdx) => rankIdx < index)
      ?.map(({ roundAllotment }) => roundAllotment)
      ?.reduce((a, b) => a + b, 0)
    return topLevelPercentage
  }

  const getCalculatedRankList = (value, id, index) => {
    let topLevelPercentage = getAvlPercentage(index, value)
    let totalCount = rankingList?.length - (index + 1)
    let remPercentage = 100 - (value + topLevelPercentage)
    let eachRankVlaue = Math.floor(remPercentage / totalCount)
    let remainder = remPercentage % totalCount
    let possiblePercentage = 100 - topLevelPercentage

    let updatedRankList = rankingList?.map((rank, rankIndex) => {
      if (rank?.id === id) {
        return {
          ...rank,
          roundAllotment:
            value <= possiblePercentage ? value : possiblePercentage,
        }
      } else if (rankIndex === index + 1) {
        return {
          ...rank,
          roundAllotment: eachRankVlaue <= 0 ? 0 : eachRankVlaue + remainder,
        }
      } else if (rankIndex > index + 1) {
        return {
          ...rank,
          roundAllotment: eachRankVlaue <= 0 ? 0 : eachRankVlaue,
        }
      } else {
        return rank
      }
    })
    return updatedRankList
  }

  const onChangesConfig = (value, id, index, isAfterChange) => {
    let updatedRankList = getCalculatedRankList(Number(value), id, index)
    updateRankingForm(updatedRankList)
    if (isAfterChange) {
      let sortedList = updatedRankList.sort(
        (a, b) => parseInt(b.roundAllotment) - parseInt(a.roundAllotment)
      )
      setRankingList(sortedList)
    }
  }

  const onSubmitFormData = async value => {
    setIsSubmit(true)
    let response = await dispatch(
      updateRoleRankingConfig(selectedRoleId, value)
    )
    if (response?.status >= 200 && response?.status < 300) {
      SuccessMessage('Ranking Configuration Updated successfully.')
      setOpenDrawer(false)
      setIsSubmit(false)
      if (setPreviewDrawe) setPreviewDrawe(true)
    } else {
      ErrorMessage(response?.response?.data?.message)
      setIsSubmit(false)
    }
  }

  const content = () => {
    return (
      <Fragment>
        {!isLoading && (
          <SpinWrapper center alignCenter>
            <Spin />
          </SpinWrapper>
        )}
        {!allowToUpdate
          ? isLoading && (
              <Fragment>
                <AlertTag>
                  <AlertIcon />
                  <AlertText>
                    Once the drive is created no changes can be made in ranking
                    configuration.
                  </AlertText>
                </AlertTag>
                <Form
                  scrollToFirstError
                  onFinish={onSubmitFormData}
                  id={'candidateRankForm'}
                  form={form}
                  layout="vertical"
                >
                  <Flex column>
                    {rankingList?.map((rank, index) => {
                      return (
                        <Fragment key={rank.name}>
                          <div>
                            <Label>{rank?.name}</Label>
                            <FormItem name={['roleRankConfigs', index, 'id']} />
                            <RangeSliderInput
                              inputValue={rank?.roundAllotment}
                              onChange={value =>
                                onChangesConfig(value, rank?.id, index, false)
                              }
                              onAfterChange={value =>
                                onChangesConfig(value, rank?.id, index, true)
                              }
                              onBlur={value =>
                                onChangesConfig(
                                  value?.target?.value,
                                  rank?.id,
                                  index,
                                  true
                                )
                              }
                              defaultValue={rank?.roundAllotment}
                              sliderName={[
                                'roleRankConfigs',
                                index,
                                'roundAllotment',
                              ]}
                              inputName={[
                                'roleRankConfigs',
                                index,
                                'roundAllotment',
                              ]}
                              disabled={rank?.roundAllotment === 0}
                            />
                          </div>
                          {index !== rankingList?.length - 1 && <Divider />}
                        </Fragment>
                      )
                    })}
                  </Flex>
                </Form>
              </Fragment>
            )
          : isLoading && (
              <Fragment>
                <DetailsTitleDiv>Details</DetailsTitleDiv>
                <RightFlex column>
                  {rankingList?.map((rank, index) => {
                    return (
                      <LeftFlex key={index + rank?.name}>
                        <DetailsNameDiv>{rank.name}</DetailsNameDiv>
                        <ContentDiv>{rank.roundAllotment}</ContentDiv>
                      </LeftFlex>
                    )
                  })}
                </RightFlex>
                <Space />
                <AlertTag>
                  <AlertIcon />
                  <AlertText>
                    Ranking Configuration of Candidate has already been updated
                    for this role.
                  </AlertText>
                </AlertTag>
              </Fragment>
            )}
      </Fragment>
    )
  }

  const footer = () => {
    return (
      !allowToUpdate && (
        <FlexWrap right>
          <Button.Secondary
            text={setCreaterDriveDrawer ? 'Back' : 'Cancel'}
            onClick={() => {
              setOpenDrawer(false)
              if (setCreaterDriveDrawer) setCreaterDriveDrawer(true)
            }}
          />
          <Button.Primary
            htmlType="submit"
            form="candidateRankForm"
            text={'Update'}
            loading={isSubmit}
          />
        </FlexWrap>
      )
    )
  }
  return (
    <Drawer
      width="40%"
      title={`Candidate Ranking Configuaration ${
        !allowToUpdate ? '' : 'Preview'
      }`}
      placement="right"
      closable={true}
      onClose={() => setOpenDrawer(false)}
      visible={openDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default CandidateRankingDrawer
